import { useApi } from '@/api/useApi.ts';
import { IGeneralUserAccessResponseDto } from '@/interfaces/auth/IGeneralUserAccessResponse.ts';
import { IPowerMarketsAccessResponseDto } from '@/interfaces/auth/IPowerMarketsGbAccess.ts';
import { IFlexIndexAccess } from '@/interfaces/benchmarks/flexIndex/IFlexIndexAccess.ts';

const powerMarketsUserSettingsApiCall = useApi('userSettings');
const apiStaticCall = useApi('static');
const accessApi = useApi('accessApi');
const flexIndexApiBase = useApi('flexIndex');

async function getGeneralAccess (): Promise<IGeneralUserAccessResponseDto> {
    return (await accessApi.get<IGeneralUserAccessResponseDto>({ endpoint: '/UserAccess' })).data;
}

async function getUserHasPowerMarketsAccess (): Promise<boolean> {
    return (await powerMarketsUserSettingsApiCall.get<boolean>({ endpoint: '/emailaccess' })).data;
}

async function getUserAccess () : Promise<IPowerMarketsAccessResponseDto> {
    return (await apiStaticCall.get<IPowerMarketsAccessResponseDto>({ endpoint: '/userAccess' })).data;
}

async function getFlexIndexAccess (): Promise<IFlexIndexAccess> {
    const response = await flexIndexApiBase.get<IFlexIndexAccess>({
        endpoint: '/getUserAccess',
    });
    return response.data;
}

async function acceptEnactTerms () : Promise<void> {
    await accessApi.get<void>({ endpoint: '/UserAccess/acceptEnactTerms' });
}

export const authApi = {
    getUserHasPowerMarketsAccess,
    getGeneralAccess,
    acceptEnactTerms,
    getUserAccess,
    getFlexIndexAccess,
};
